import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { MotifModule } from '@ey-xd/motif-wc-angular';
import {
  IconoirHome,
  IconoirTable,
  IconoirUserBadgeCheck,
  IconoirPageStar,
  IconoirMenu,
} from '@ey-xd/motif-icon';

interface NavItem {
  icon: any;
  link: string;
  label: string;
}

@Component({
  selector: 'app-sidebar-nav',
  standalone: true,
  imports: [CommonModule, RouterLink, RouterLinkActive, MotifModule],
  templateUrl: './sidebar-nav.component.html',
  styleUrl: './sidebar-nav.component.scss',
})
export class SidebarNavComponent {
  IconoirHome = IconoirHome;
  IconoirTable = IconoirTable;
  IconoirUserBadgeCheck = IconoirUserBadgeCheck;
  IconoirPageStar = IconoirPageStar;
  IconoirMenu = IconoirMenu;

  expanded = false;

  toggleSidebar(): void {
    this.expanded = !this.expanded;
  }

  navItems: NavItem[] = [
    {
      icon: this.IconoirHome,
      link: '',
      label: 'Home',
    },
    {
      icon: this.IconoirTable,
      link: '/tb-agent',
      label: 'Trial Balance Extraction Agent and UK Chart of Account Mapping Agent',
    },
    {
      icon: this.IconoirUserBadgeCheck,
      link: '/agent-five',
      label: 'Corporate Income Tax Review Agent',
    },
    {
      icon: this.IconoirPageStar,
      link: '/ixbrl',
      label: 'iXBRL Agent',
    },
  ];
}
